import React from 'react';
import DiagnosisChart from '../Common/WellDiagnosisChart';

interface GradientTraverseChartProps {
  chartData: any;
  parameters: any;
}

const GradientTraverseChart: React.FC<GradientTraverseChartProps> = ({ chartData, parameters }) => {
  return (
    <DiagnosisChart
      chartData={chartData}
      seriesConfig={parameters}
      widgetHeader='Gradient traverse plot'
      xAxisLabel='Pressure (psig)'
      yAxisLabel='Measured depth (ft)'
      chartLabel={chartData.ChartLabel}
      invertYAxis={true}
    />
  );
};

export default GradientTraverseChart;
